import { useEffect, useState } from "react";
import axios from "axios";

export default function HeroAdmin() {
  const [hero, setHero] = useState(null);

  useEffect(() => {
    axios.get("/get_hero.php").then(res => {
      setHero(res.data);
    });
  }, []);

  if (!hero) return <p>Carregando...</p>;

  const handleChange = e => {
    setHero({ ...hero, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    axios.post("/update_hero.php", hero).then(() => {
      alert("Hero atualizado com sucesso!");
    });
  };

  return (
    <div className="mx-auto max-w-3xl p-6">
      <h1 className="mb-6 text-xl font-semibold">
        Administração do Hero
      </h1>

      <input
        name="title"
        value={hero.title}
        onChange={handleChange}
        className="mb-3 w-full rounded border p-2"
        placeholder="Título"
      />

      <textarea
        name="subtitle"
        value={hero.subtitle}
        onChange={handleChange}
        className="mb-3 w-full rounded border p-2"
        placeholder="Subtítulo"
      />

      <textarea
        name="description"
        value={hero.description}
        onChange={handleChange}
        className="mb-3 w-full rounded border p-2"
        placeholder="Descrição"
      />

      <input
        name="button_text"
        value={hero.button_text}
        onChange={handleChange}
        className="mb-3 w-full rounded border p-2"
        placeholder="Texto do botão"
      />

      <input
        name="button_color"
        value={hero.button_color}
        onChange={handleChange}
        className="mb-3 w-full rounded border p-2"
        placeholder="Cor do botão (ex: emerald-600)"
      />

      <textarea
        name="whatsapp_message"
        value={hero.whatsapp_message}
        onChange={handleChange}
        className="mb-3 w-full rounded border p-2"
        placeholder="Mensagem WhatsApp"
      />

      <button
        onClick={handleSave}
        className="mt-4 rounded bg-emerald-600 px-6 py-2 text-white"
      >
        Salvar alterações
      </button>
    </div>
  );
}
